import { useEffect, useState } from "react";
import { PrintJson } from "../../../../modules/theme/Component/PrintJson";
import { BreadcrumbNav } from "./Components/BreadCrumb";
import { NotFound } from "../../../../modules/theme/NotFound";
import { VisualBandeja } from "../../../../modules/admin/perfil/VisualBandeja";
import { PersonalAccountData } from "./Components/PersonarDataUser/PersonalAccountData";
import { LoanLineCredits } from "./Components/CreditLines/LoanLineCredits";
import { PerosnalInbox } from "../../../../modules/bpm/PersonaInbox/Personalnbox";
import { ActiveCredits } from "./Components/ActiveCredits/ActiveCredits";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _AccountINFORPO, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { CreditsLoans } from "./Components/CreditsLoans/CreditsLoans";
import { QuickTurnStart } from "./Components/QuickTurnStart/QuickTurnStart";
import { configPortal } from "../../../../configPortal";
import { AccountDataViewerEditor } from "./Components/PersonarDataUser/AccountDataViewerEditor";
import { HistoryAppointmen } from "./Components/HistoryAppointmen/HistoryAppointmen";
import { ActiveAppointments } from "./Components/ActiveAppointments/ActiveAppointments";
import { QuickTurnExecute } from "./Components/QuickTurnExcute/QuickTurnExcecute";
import { MyAdquisitionContract } from "./Components/MyAdquisitionContract/MyAdquisitionContract";
import { MyAdquisitionContractDetail } from "./Components/MyAdquisitionContract/MyAdquisitionContractDetail/MyAdquisitionContractDetail";

interface urlParam {
    page: string;
    parametro: string;
    atributo?: string;
};
interface Props {
    urlElement: urlParam;
}
export const IndexPage = ({ urlElement }: Props) => {

    const { instance } = useDataBean(_AccountINFORPO)
    const portalMenus: number = configPortal.MENUS_PORTAL ?? 1;

    useEffect(() => {
        if (portalMenus === 2) {

        } else {
            getUserInforpo()
        }
    }, [])

    const getUserInforpo = () => {
        const prop = {
            NUMERO_IDENTIFICACION: _single.getAccount().Nit
        }
        instance.getAffiliateInforpo(1, 15, prop).then(
            (resp) => {
                _single.setSessionItem("AccInforpo", JSON.stringify(resp.List[0].DataBeanProperties));
            }
        ).catch(
            err => { toast.error(err) }
        )

    }


    const [url, setUrl] = useState<Partial<urlParam>>({});

    useEffect(() => {
        setUrl(urlElement);
    }, [urlElement]);

    const renderSwitch = (url: string) => {

        switch (url) {
            case 'mesagges':
                return (<VisualBandeja key={url} />);
            case 'personal-info':
                return <PersonalAccountData idAffiliate={_single.getAccountID()} _PayrollType={_single.getAffiliate()?.IDCajaNominadora} />;
            case 'personal-account-info':
                return <AccountDataViewerEditor idAccount={_single.getAccountID()} />;
            case 'credit-lines':
                return <LoanLineCredits />;
            case 'credits-loans':
                return <CreditsLoans />;
            case 'requests':
                return <PerosnalInbox FilterCode="CRE" />;
            case 'products':
                return <ActiveCredits idAccount={_single.getAccountID()} />;
            case 'init-turn':
                return <QuickTurnStart ChannelAtention={13} />;
            case 'history-turn':
                return <HistoryAppointmen />;
            case 'active-turn':
                return <ActiveAppointments />;
            case 'tramites-virtuales':
                return <QuickTurnStart ChannelAtention={14} />;
            case 'services':
                return <QuickTurnExecute />;
            case 'mi-contract':
                return <MyAdquisitionContract />;
            case 'mi-contract-detail':
                return <MyAdquisitionContractDetail />;

            default:
                return <NotFound />;
        }
    }

    return (
        <div className="row">
            <BreadcrumbNav urlElement={url} />
            <div className="col-md-12" style={{ flex: 1, height: "85%" }}>
                {renderSwitch(urlElement.parametro)}
            </div>
        </div>
    )
}